module.exports = __webpack_public_path__ + "img/accepted_card_logos.9ebbdef.svg";